import { render, staticRenderFns } from "./ShareTile.vue?vue&type=template&id=2c3f343e&"
import script from "./ShareTile.vue?vue&type=script&lang=js&"
export * from "./ShareTile.vue?vue&type=script&lang=js&"
import style0 from "./ShareTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports